import * as React from "react";

import Link from "@mui/material/Link";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

import { isBefore } from "date-fns";

import { ReportNotification } from "services/types/notifications";

const ReportNotificationComponent = ({
  title,
  description,
  extra
}: ReportNotification) => {
  const notificationIsExpired = isBefore(
    extra.expires_utc_epoch * 1000,
    new Date()
  );

  const downloadUrl =
    "csv_download_url" in extra
      ? extra.csv_download_url
      : extra.xlsx_download_url;
  const downloadTitle =
    "csv_title" in extra ? extra.csv_title : extra.xlsx_title;

  return (
    <ListItemText
      primary={title}
      secondary={
        <Stack component="span" gap={0.5}>
          <Typography component="span">{description}</Typography>
          {title.startsWith("Report is ready") &&
            (notificationIsExpired ? (
              <Typography fontStyle="italic" color={grey[800]}>
                Download link was expired
              </Typography>
            ) : (
              <Link
                href={downloadUrl}
                download={downloadTitle}
                underline="hover"
                width="min-content"
              >
                Download
              </Link>
            ))}
        </Stack>
      }
    />
  );
};

export default ReportNotificationComponent;
